import { initialState } from "../store/store";

export function AppReducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state
  }
}
